const ABMLClassCore = require("../core/ABMLClassCore");
module.exports = class ABMLClass extends ABMLClassCore {};
